import emojiRegex from 'emoji-regex';

/**
 * Remove all emoji in element
 * @param {HTMLElement} element - element to remove emoji from
 * @return {void}
 */
const removeEmojiFromElement = (element) => {
  const regex = emojiRegex();
  if (element.tagName === 'TEXTAREA' || element.tagName === 'INPUT') {
    // eslint-disable-next-line no-param-reassign
    element.value = element.value.replace(regex, '');
  }
};

/**
 * Remove all emoji in string
 * @param {string} str - string to remove emoji from
 * @return {string} out string
 */
const removeEmojiFromString = (str) => {
  const regex = emojiRegex();
  return str.replace(regex, '');
};

export { removeEmojiFromElement, removeEmojiFromString };
